<template>
  <pt-trust-deed-list ref="billTable" class="pt-trust-deed-list__withData" @billsExportExcel="billsExportExcel" :exportLoading="exportLoading" @billsExportPdf="billsExportPdf"
	:downloadLoading="downloadLoading" @deleteBills="deleteBills" :deleteLoading="deleteLoading"></pt-trust-deed-list>
</template>

<script>
import PtTrustDeedList from './index'
export default {
  name: 'pt-trust-deed-list__withData',
  components: {
    'pt-trust-deed-list': PtTrustDeedList
  },
  data () {
    return {
			exportLoading: false,
      downloadLoading: false,
      downloadReportLoading: false,
      deleteLoading:false
      
    }
  },
  methods: {
    billsExportExcel (params) {
      let data = {
        ...params
      }
      this.exportLoading = true
      this.$store.dispatch('billsExportExcel', data).then(res => {
        this.$message.success('委托单导出成功')
        this.exportLoading = false
      }).catch(err => {
        this.$message.error(err || '委托单导出失败')
        this.exportLoading = false
      })
		},
		billsExportPdf(params,type){
			let data={
				...params
      }
      if (type === 'report') {
        this.downloadReportLoading=true
      } else {
        this.downloadLoading = true
      }
      let api = type === 'report' ? 'billsExportReport' : 'billsExportPdf'
			this.$store.dispatch(api,data).then(res=>{
        this.$message.success(type === 'report'?'报告下载成功':'委托单下载成功')
			}).catch(err=>{
				this.$message.error(err || type === 'report' ? '报告下载失败': '委托单下载失败')
      }).finally(_ => {
        if (type === 'report') {
          this.downloadReportLoading = true
        } else {
          this.downloadLoading = false
        }
      })
    },
    deleteBills (ids) {
      this.deleteLoading=true
      this.$store.dispatch('deleteBills', ids).then(res => {
        this.$message.success('删除委托单成功')
        this.deleteLoading = false
        this.$refs.billTable.reload()
      }).catch(err => {
        this.deleteLoading=false
        this.$message.error(err||'删除委托单失败')
      })
    }
  }
}
</script>
